// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1676":"029fec2c","2086":"e7ee4404","2256":"7c2732ee","4036":"31d6cfe0","8800":"9cf2a1c4"}[chunkId] + ".chunk.css";
};